import { ReactNode } from 'hoist-non-react-statics/node_modules/@types/react'
import { VFC } from 'react'
import ReactLinkify, { Props as ReactLinkifyProps } from 'react-linkify'
import styled from 'styled-components'

const componentDecorator: ReactLinkifyProps['componentDecorator'] = (
  href,
  text,
  key,
) => (
  <a key={key} href={href} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
)

export const Linkify: VFC<ReactLinkifyProps & { children: ReactNode }> = ({
  children,
  ...props
}) => {
  return (
    <ReactLinkify componentDecorator={componentDecorator} {...props}>
      {children}
    </ReactLinkify>
  )
}

const URL_REGEX = /(https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)/g

const convertUrlToLink = (text: string, reg?: RegExp) =>
  text.split(URL_REGEX).map((word: string, index) => {
    if (word.match(URL_REGEX))
      return (
        <a href={word} target="_blank" rel="noopener noreferrer" key={index}>
          <HighLightComponent key={index} word={word} index={index} reg={reg} />
        </a>
      )
    return (
      <HighLightComponent key={index} word={word} index={index} reg={reg} />
    )
  })

export const HighLightComponent: VFC<{
  word: string
  index: number
  reg?: RegExp
}> = ({ word, index, reg }) => (
  <HighLight>
    {reg ? (
      <span
        dangerouslySetInnerHTML={{
          __html: word.replace(reg, '<span class="highlight">$1</span>'),
        }}
      />
    ) : (
      <span key={index}>{word}</span>
    )}
  </HighLight>
)

export const CustomLinkify: VFC<{
  children: string
  className?: string
  reg?: RegExp
}> = ({ children, className, reg }) => (
  <CusutomLinkifyP className={className}>
    {convertUrlToLink(children, reg)}
  </CusutomLinkifyP>
)

const CusutomLinkifyP = styled.p`
  line-height: 1.5;
  white-space: pre-wrap;
  letter-spacing: 0.05em;
  > a {
    text-decoration: underline;
  }
`

const HighLight = styled.span`
  .highlight {
    display: inline-block;
    background: #faff00;
  }
`
